<template>
  <div
    class="feedback-form-images-input"
    :class="{ 'feedback-form-images-input_disabled': isDisabled }"
  >
    <label class="feedback-form-images-input-text">
      <IconUploadImage />

      <span class="feedback-form-images-input-text-label">Добавить фото</span>

      <input
        ref="inputFile"
        :disabled="isDisabled"
        type="file"
        multiple
        accept="image/*"
        class="hidden-input"
        @change="addImage"
      />
    </label>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue';
  import { FeedbackForm } from './types/feedbackForm';
  import IconUploadImage from '../icons/IconUploadImage.vue';

  const props = defineProps<{
    form: FeedbackForm;
    isDisabled?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'set-images', value: File[]): void;
  }>();

  const inputFile = ref<HTMLInputElement | null>(null);

  const addImage = () => {
    if (!inputFile.value) return;

    const { files } = inputFile.value;

    if (files) {
      emit('set-images', [...props.form.images, ...Array.from(files)]);
    }

    inputFile.value.value = '';
  };

  watch(
    () => props.form.images,
    newImages => {
      if (!inputFile.value?.files) return;

      const inputFiles = Array.from(inputFile.value.files);
      const formImages = newImages;

      const inputFileNames = new Set(inputFiles.map(file => file.name));
      const formImageNames = new Set(formImages.map(file => file.name));

      if (
        inputFileNames.size !== formImageNames.size ||
        !Array.from(inputFileNames).every(name => formImageNames.has(name))
      ) {
        inputFile.value.value = '';
      }
    },
    { deep: true }
  );
</script>

<style>
  .feedback-form-images-input {
    display: flex;
    align-items: center;
    gap: 12px;

    &_disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    &-text {
      cursor: pointer;
      user-select: none;
      font-size: 18px;
      color: #006dda;
      transition: color 0.2s ease;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;

      &:hover {
        opacity: 0.7;
      }
    }

    .hidden-input {
      position: absolute;
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      z-index: -1;
    }

    &-text {
      svg {
        width: 32px;
        height: 32px;
      }
    }
  }

  @media (--mobile) {
    .feedback-form-images-input {
      &-text-label {
        display: none;
      }
    }
  }
</style>
